import { ICON_COLORS as IC, ROOT_TOKENS_COLORS as RTC } from '@constants/colors.ts';
import { DESKTOP_SIZES, FONT_FAMILY, SIZES } from '@constants/fonts.ts';
import styled from 'styled-components';

export const ProfileBarWrapper = styled.div`
    position: relative;
    margin-left: auto;
`;

export const ContentWrapper = styled.div`
    display: flex;
    gap: 18px;
    align-items: center;
    user-select: none;
`;

export const Info = styled.div`
    display: flex;
    flex-direction: column;
    text-align: right;
    margin-top: 2px;
`;

export const NotificationWrapper = styled.div`
    background: ${RTC.blue.default};
    border-radius: 50%;
    position: relative;
    max-height: 40px;
    cursor: pointer;
`;

export const NotificationCount = styled.div`
    color: ${RTC.white.default};
    position: absolute;
    top: -2px;
    background: ${IC.error};
    border-radius: 50%;
    left: 28px;
    cursor: pointer;
    ${FONT_FAMILY.poppins};
    ${DESKTOP_SIZES[SIZES.BODY_XS].fontSize}
    ${DESKTOP_SIZES[SIZES.BODY_SM].fontWeight};
    width: 30px;
    height: 30px;
    min-width: 30px;
    min-height: 30px;
    display: grid;
    place-items: center;
    line-height: 1;
    box-sizing: border-box;
    white-space: nowrap;
    overflow: visible;
    z-index: 1;
`;

export const AvatarWrapper = styled.div`
    display: flex;
    align-items: center;
    gap: 10px;
    cursor: pointer;
`;

export const Avatar = styled.div`
    display: flex;
    img {
        border-radius: 50%;
        width: 40px;
        height: 40px;
    }
`;

export const Toggler = styled.div`
    color: ${RTC.blue.default};
    cursor: pointer;
    user-select: none;
    display: flex;
`;
